import React from 'react'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { InsightData } from 'schemas/action/InsightDataSchema'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import Media from 'components/insightContent/Media'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getDisplayText } from 'components/widget/WordCloudWidgets/share/utils'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'

const DIALOG_CONTENT_HEIGHT = '476px'

interface InsightModalProps {
  open: boolean
  onClose: () => void
  title?: string
  selectedInsights?: InsightData[]
  detailSetting: InsightContentSettingType
  widgetSettingWithSelection: any
}

const InsightModal = ({
  open,
  title,
  selectedInsights,
  onClose,
  detailSetting,
  widgetSettingWithSelection
}: InsightModalProps) => {
  const theme = useDisplayTheme() as Theme

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose} width="728px">
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        {selectedInsights?.map((item: InsightData) => (
          <StyledTermContainer key={item.name}>
            <StyledTermContent mode={theme}>
              {getDisplayText(item.name!, detailSetting.viewOption, {})}
            </StyledTermContent>
          </StyledTermContainer>
        ))}
        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <Media title={title} detailSetting={detailSetting} />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
